export { default as CorporateEditTemplate } from './CorporateEdit';
export { default as CorporateListTemplate } from './CorporateList';
export { default as CorporatePreviewTemplate } from './CorporatePreview';
